/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Seller_Dashboard_Upgrade_TitleInputs */

const en_seller_dashboard_upgrade_title = /** @type {(inputs: Seller_Dashboard_Upgrade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Free Tier, ${i?.fee}% platform fee`)
};

const es_seller_dashboard_upgrade_title = /** @type {(inputs: Seller_Dashboard_Upgrade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nivel Gratis — ${i?.fee}% comisión de plataforma`)
};

const fr_seller_dashboard_upgrade_title = /** @type {(inputs: Seller_Dashboard_Upgrade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Niveau Gratuit — ${i?.fee} % de frais de plateforme`)
};

const de_seller_dashboard_upgrade_title = /** @type {(inputs: Seller_Dashboard_Upgrade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kostenlose Stufe — ${i?.fee}% Plattformgebühr`)
};

const ja_seller_dashboard_upgrade_title = /** @type {(inputs: Seller_Dashboard_Upgrade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`無料プラン — 手数料${i?.fee}%`)
};

const zh_seller_dashboard_upgrade_title = /** @type {(inputs: Seller_Dashboard_Upgrade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费版 — ${i?.fee}% 平台费`)
};

const ar_seller_dashboard_upgrade_title = /** @type {(inputs: Seller_Dashboard_Upgrade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`الباقة المجانية — رسوم منصة ${i?.fee}%`)
};

const id_seller_dashboard_upgrade_title = /** @type {(inputs: Seller_Dashboard_Upgrade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paket Gratis — Biaya platform ${i?.fee}%`)
};

const it_seller_dashboard_upgrade_title = /** @type {(inputs: Seller_Dashboard_Upgrade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piano Gratuito — Commissione ${i?.fee}%`)
};

const ru_seller_dashboard_upgrade_title = /** @type {(inputs: Seller_Dashboard_Upgrade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Бесплатный тариф — комиссия платформы ${i?.fee}%`)
};

const pt_seller_dashboard_upgrade_title = /** @type {(inputs: Seller_Dashboard_Upgrade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plano Grátis — ${i?.fee}% de taxa de plataforma`)
};

const ko_seller_dashboard_upgrade_title = /** @type {(inputs: Seller_Dashboard_Upgrade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`무료 요금제 — 플랫폼 수수료 ${i?.fee}%`)
};

/**
* | output |
* | --- |
* | "Free Tier, {fee}% platform fee" |
*
* @param {Seller_Dashboard_Upgrade_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_upgrade_title = /** @type {((inputs: Seller_Dashboard_Upgrade_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Upgrade_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_upgrade_title(inputs)
	if (locale === "es") return es_seller_dashboard_upgrade_title(inputs)
	if (locale === "fr") return fr_seller_dashboard_upgrade_title(inputs)
	if (locale === "de") return de_seller_dashboard_upgrade_title(inputs)
	if (locale === "ja") return ja_seller_dashboard_upgrade_title(inputs)
	if (locale === "zh") return zh_seller_dashboard_upgrade_title(inputs)
	if (locale === "ar") return ar_seller_dashboard_upgrade_title(inputs)
	if (locale === "id") return id_seller_dashboard_upgrade_title(inputs)
	if (locale === "it") return it_seller_dashboard_upgrade_title(inputs)
	if (locale === "ru") return ru_seller_dashboard_upgrade_title(inputs)
	if (locale === "pt") return pt_seller_dashboard_upgrade_title(inputs)
	return ko_seller_dashboard_upgrade_title(inputs)
});